export const USERS_DATA = [
  {
    id: 1,
    Id: "01",
    userName: "John Doe",
    role: "Manager",
    
    createdOn: 30 / 4 / 2011,
  },
  {
    id: 2,
    Id: "02",
    userName: "John Doe",
    role: "Admin",
    createdOn: 30 / 4 / 2011,
  },
  {
    id: 3,
    Id: "03",
    userName: "John Doe",
    role: "Admin",
    createdOn: 30 / 4 / 2011,
  },
];
